"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.save = save;
function save(url, obj) {
    var _a, _b;
    fetch(url, {
        method: 'POST',
        headers: {
            'X-CSRF-TOKEN': (_b = (_a = document.querySelector('meta[name="csrf-token"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content')) !== null && _b !== void 0 ? _b : '',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(obj),
    })
        .then((r) => r.json());
}
